import { Outlet } from 'react-router-dom';
import { IdleTimeoutGuard } from '@/components/auth/IdleTimeoutGuard';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { SideNav } from './SideNav';
import { TopBar } from './TopBar';

export function AuthedLayout() {
  return (
    <IdleTimeoutGuard>
      <SidebarProvider className="bg-background">
        <SideNav />
        <SidebarInset className="overflow-hidden">
          <TopBar />
          <div className="flex-1 overflow-y-auto">
            <div className="mx-auto max-w-7xl p-6">
              <Outlet />
            </div>
          </div>
        </SidebarInset>
      </SidebarProvider>
    </IdleTimeoutGuard>
  );
}
